import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

function useWindowSize() {
  var _useState = useState({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  useEffect(function () {
    var isUnmounted = false;

    var updateWindowSize = function updateWindowSize() {
      if (isUnmounted) {
        return;
      }
      /**
       * Set window width/height to state
       */


      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    var handleResize = debounce(updateWindowSize, 50);
    window.addEventListener('resize', handleResize);
    updateWindowSize();
    return function () {
      isUnmounted = true;
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

export default useWindowSize;